// src/components/AppointmentForm.jsx
import { Link } from 'react-router-dom';
import SectionTitle from '../common/SectionTitle';
import Button from '../common/Button';
import clinicImage from '../../Assets/TeamandOthers/HomeContact.jpg';
// Suggestion: Use a "Smiling Patient" or "Modern Equipment" image for the right side
import secondaryImage from '../../Assets/TeamandOthers/Homeappform.jpg'; 

const AppointmentForm = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-blue-50 via-indigo-50/40 to-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-blue-200 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-indigo-100 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-5 sm:px-6 lg:px-8 relative">
        <SectionTitle
          title="Schedule Your Visit Today"
          subtitle="Experience world-class dental healthcare designed around your comfort."
          className="mb-10 md:mb-12 text-center max-w-4xl mx-auto"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          
          {/* LEFT: Main Clinic Image + Why Choose Us */}
          <div className="flex flex-col space-y-6 lg:pr-4 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl shadow-blue-100/30 border-4 border-white">
              <img
                src={clinicImage}
                alt="Dr. Sridhar Dental Hospital Interior"
                className="w-full h-auto object-cover aspect-[16/9]"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent flex items-end p-5">
                <p className="text-white text-sm md:text-base font-medium drop-shadow">
                  Excellence in Dentistry Since 1995
                </p>
              </div>
            </div>

            <div className="space-y-4 text-center lg:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-gray-800">
                Why Choose Dr. Sridhar International Dental Hospitals & Research Center 
              </h3>
              <ul className="space-y-3 text-gray-700 text-base text-left inline-block">
                <li className="flex items-center gap-3">
                  <span className="text-blue-600 bg-blue-100 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold">✓</span>
                  Painless treatments with advanced equipment
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-blue-600 bg-blue-100 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold">✓</span>
                  Expert care in implants, braces & cosmetics
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-blue-600 bg-blue-100 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold">✓</span>
                  Flexible timings in Vijayawada & Hyderabad
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-blue-600 bg-blue-100 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold">✓</span>
                  Thousands of happy, confident smiles
                </li>
              </ul>
              <p className="text-gray-600 text-sm italic pt-1">
                "Your comfort and smile are our top priority."
              </p>
            </div>
          </div>

          {/* RIGHT: Content + Action Card */}
          <div
            className="
              bg-white
              rounded-[2rem] 
              shadow-2xl shadow-blue-100/50 
              border border-blue-50
              p-8 md:p-12 
              flex flex-col justify-center items-center text-center
              transition-all duration-300 hover:shadow-blue-200/40
              order-1 lg:order-2
            "
          >
            <div className="max-w-md mx-auto space-y-8">
              {/* 3-4 Lines of Content */}
              <div className="space-y-4">
                <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight">
                  Your Journey to a Perfect Smile Starts Here
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed">
  Book your dental appointment quickly and stress-free.
  Select your nearest Vijayawada or Hyderabad branch and take the first step toward better oral health.
</p>
              </div>

              {/* Secondary Image below text */}
              <div className="rounded-2xl overflow-hidden shadow-lg border-2 border-white transform hover:rotate-1 transition-transform">
                <img 
                  src={secondaryImage || clinicImage} 
                  alt="Smile Consultation" 
                  className="w-full h-48 object-cover"
                />
              </div>

              {/* Navigation Button */}
              <div className="pt-4">
                <Link to="/book-appointment">
                  <Button
                    className="
                      w-full py-5 px-10 text-xl font-bold rounded-2xl
                      bg-gradient-to-r from-blue-600 to-indigo-600
                      hover:from-blue-700 hover:to-indigo-700
                      text-white shadow-xl shadow-blue-200/50
                      transition-all duration-300 hover:scale-[1.02] active:scale-95
                      flex items-center justify-center gap-3
                    "
                  >
                    Book Your Appointment
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Button>
                </Link>
                <p className="text-gray-400 text-sm mt-5 font-medium">
                  Quick Appointments • No Waiting
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AppointmentForm;